import { useQuery } from '@tanstack/react-query';

import { useAuthStore } from '../../stores/authStore';
import { client } from '../client';
import { QueryKeys } from '../query-keys';

import type { ProfileData } from '../../types/ProfileData';

type ProfileResponse = { result?: ProfileData; isAdmin: boolean; message?: string };

const getProfile = async () => {
  const resV2 = await client.get<ProfileResponse>('/v2/me');
  if (resV2.data && resV2.status !== 404) return resV2.data;

  const resV1 = await client.get<ProfileResponse>('/v1/me');
  if (resV1.data && resV1.status !== 404) return resV1.data;

  throw new Error('Failed to fetch profile');
};

export const useProfile = () => {
  const setIsAdmin = useAuthStore((state) => state.setIsAdmin);
  const accessToken = useAuthStore((state) => state.accessToken);

  return useQuery<ProfileResponse>({
    queryKey: QueryKeys.Profile,
    queryFn: async () => {
      const res = await getProfile();
      res.isAdmin && setIsAdmin(res.isAdmin);
      return res;
    },

    enabled: Boolean(accessToken),
  });
};
